export const useScrollListenerMixin = (
  refScrollElement = 'scrollableElement',
  eventHandlers = {
    scrollUp: undefined,
    scrollDown: undefined
  },
  addEventListener = true) => {
  const uppercaseRef = refScrollElement.charAt(0).toUpperCase() + refScrollElement.slice(1)

  const scrollEventHandler = `handle${uppercaseRef}`
  const settings = `scroll${uppercaseRef}`

  const add = `add${uppercaseRef}ScrollListener`
  const remove = `remove${uppercaseRef}ScrollListener`

  const setScrollY = `set${uppercaseRef}ScrollY`
  const hasScroll = `${refScrollElement}HasScroll`
  return {
    data () {
      return {
        [settings]: {
          scrolledY: 0,
          disabled: false
        }
      }
    },
    computed: {
      [refScrollElement] () {
        return this.$refs[refScrollElement]
      }
    },
    mounted () {
      if (addEventListener) this[add]()
    },
    beforeDestroy () {
      if (addEventListener) this[remove]()
    },
    methods: {
      [add] () {
        this[refScrollElement].addEventListener('scroll', this[scrollEventHandler])
      },
      [remove] () {
        this[refScrollElement].removeEventListener('scroll', this[scrollEventHandler])
      },
      [scrollEventHandler] (event) {
        if (!this[settings].disabled) {
          const hasScrollY = this[refScrollElement].scrollHeight > this[refScrollElement].clientHeight

          if (hasScrollY) {
            const scrollHeight = Math.ceil(this[refScrollElement].scrollTop + this[refScrollElement].clientHeight)

            if (this.scrolledY !== scrollHeight && scrollHeight >= this[refScrollElement].scrollHeight - 5) {
              this[settings].scrolledY = scrollHeight

              if (eventHandlers.scrollDown) this[eventHandlers.scrollDown](event)
            }

            if (this[refScrollElement].scrollTop === 0) {
              if (eventHandlers.scrollUp) this[eventHandlers.scrollUp](event)
            }
          }
        }
      },
      [setScrollY] (y) {
        this[settings].disabled = true
        this[refScrollElement].scrollTop = y
        this[settings].disabled = false
      },
      [hasScroll] () {
        return this[refScrollElement].scrollHeight > this[refScrollElement].clientHeight
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/nexum/mixins/useScrollListenerMixin.js